<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">Views &amp; permissions — {{ data.roleName }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>
  <p class="dialog-hint">Editing a role does not change users already assigned this role.</p>

  <div class="groups">
    @for(g of groups; track g.viewLabel){
    <div class="group">
      <span class="group-title">{{ g.viewLabel }}</span>
      <div class="pairs">
        @for(p of g.pairs; track p.svpId){
        <label class="pair">
          <input type="checkbox" [checked]="selected[p.svpId]" (change)="toggle(p.svpId)" />
          <span>{{ p.permission }}</span>
        </label>
        }
      </div>
    </div>
    } @empty {
    <p class="empty-row">No views available.</p>
    }
  </div>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Close</button>
    <button type="button" class="ac-primary-btn" (click)="save()">Save</button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
